import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {register, resetRegisterEditProfileForm} from 'actions/authActions';
import {createSession} from 'actions/sessionActions';
import history from 'router/history';
import RegisterForm from './registerForm';
import featureFlags from "../../featureFlags";
import {parseCookie} from "services/cookie";
import { getFeaturedProgramHelper } from 'services/programs'

@connect(
  state => ({auth: state.auth}),
  {register, resetRegisterEditProfileForm, createSession}
)
export default class Register extends Component {

  static propTypes = {
    auth: PropTypes.object.isRequired,
    register: PropTypes.func.isRequired,
    resetRegisterEditProfileForm: PropTypes.func.isRequired,
    createSession: PropTypes.func.isRequired
  };

  static contextTypes = {
    location: PropTypes.object.isRequired
  };

  componentWillMount() {
    this.props.resetRegisterEditProfileForm();
  }

  handleSubmit(data) {
    const {query} = this.context.location;
    const referral = parseCookie(tryGetCookieValue('ppa_referral')) || {};
    const {referrerUserId, referrerFirstName, referrerLastName, referrerUniqueUrl, referredProgramId} = referral;
    return this.props.register({
      ...data,
      referrerUserId,
      referrerFirstName,
      referrerLastName,
      referrerUniqueUrl,
      referredProgramId
    }).then(userId => {
        const featuredProgram = getFeaturedProgramHelper();
        if (featureFlags.autoCreateClassWhenFeaturedProgramIsPresent && featuredProgram.found) {
          const fpHelper = getFeaturedProgramHelper();
          return this.props.createSession(userId, fpHelper.programId, {
            language: fpHelper.featuredLanguage,
            grade: '4',
            divisionName: 'My Class',
            numberOfStudents: 25,
            pendingApproval: !query.contractId,
            auto: true,
            firstClass: true,
            contractId: query.contractId,
            referrerUserId
          });
        }
      })
      .then(() => {
        history.replaceState({next: null}, '/');
      });
  }

  render() {
    return <RegisterForm onSubmit={::this.handleSubmit}/>;
  }

}



// WEBPACK FOOTER //
// ./src/views/auth/register.jsx